import { SET_PDF_EMAIL } from '../../ActionTypes'

export const setPdfEmail = (inputEmail) => ({
  type: SET_PDF_EMAIL,
  inputEmail,
})
